import { Component, OnInit } from '@angular/core';
import { NavController, NavParams, LoadingController, ModalController, IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MeusGruposMinisteriosDetalhesPage } from '../meus-grupos-ministerios-detalhes/meus-grupos-ministerios-detalhes.page';
import { GrupoProvider } from 'src/app/services/grupo/grupo';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DateFormatPipe } from 'src/app/pipes/date-format/date-format';
import { NomenclaturaPipe } from 'src/app/pipes/nomenclatura/nomenclatura';
import { LoadingSpinnerComponent } from 'src/app/components/loading/loading-spinner/loading-spinner.component';
import { SemRegistroComponent } from 'src/app/components/sem-registro/sem-registro';

@Component({
  selector: 'app-meus-grupos-ministerios',
  templateUrl: './meus-grupos-ministerios.page.html',
  styleUrls: ['./meus-grupos-ministerios.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DateFormatPipe,
    TranslateModule,
    NomenclaturaPipe,
    LoadingSpinnerComponent,
    SemRegistroComponent
  ],
})
export class MeusGruposMinisteriosPage implements OnInit {
  grupos: any = [];
  tipo: any;
  loaded: boolean = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public loadingController: LoadingController,
    public grupoProvider: GrupoProvider,
    public modalCtrl: ModalController,
    private translate: TranslateService
  ) {

    this.tipo = this.navParams.get('tipo');
    this.grupoProvider.getGruposPessoa(this.navParams.get('idPessoa'), this.navParams.get('tipo')).subscribe((data) => {
      this.grupos = data;
    });
    
  }

  ngOnInit() { 
    setTimeout(() =>{
      this.loaded = true;
    }, 1000);
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }

  public async selecionarGrupo(grupo: { id: any; nome: any; }) {
    var data = { idGrupo: grupo.id, tipo: this.tipo, grupoNome: grupo.nome };
    const modalPage = await this.modalCtrl.create({ component: MeusGruposMinisteriosDetalhesPage, componentProps: data });
    modalPage.present();
  }

}
